module.exports = __webpack_public_path__ + "img/pafm_borderless_black.af01aed5.svg";